"use strict";

require("./kiwiirccom");